import { useMutation } from '@tanstack/react-query'
import { baseClient } from 'builder/modules/apiClient'

export const useMutationMagicAuth = () => {
  return useMutation(async ({ token }: { token: string }): Promise<void> => {
    const response = await baseClient.post(`/app/login/magic-auth`, {
      token,
    })

    return response.data
  })
}
